import {MenuItem, TextField} from "@mui/material";
import React from "react";

const InstallmentsSelect = ({ label, value, onChange, disabled }) => {
    const installmentOptions = {
        1: "À vista",
        2: "2x",
        3: "3x",
        4: "4x",
        5: "5x",
        6: "6x",
        7: "7x",
        8: "8x",
        9: "9x",
        10: "10x",
        11: "11x",
        12: "12x",
    };

    return (
        <TextField
            label={label}
            fullWidth
            select
            value={value}
            onChange={onChange}
            disabled={disabled}
        >
            {Object.entries(installmentOptions).map(([key, label]) => (
                <MenuItem key={key} value={key}>
                    {label}
                </MenuItem>
            ))}
        </TextField>
    );
};

export default InstallmentsSelect